/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';

var SvgRoot = /*#__PURE__*/styled.img.withConfig({
  displayName: "styledComponents__SvgRoot",
  componentId: "sc-1c8dbgg-0"
})(["height:", ";width:", ";opacity:", ";"], function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var opacity = _ref3.opacity;
  return opacity;
});
process.env.NODE_ENV !== "production" ? SvgRoot.displayName = 'SvgRoot' : undefined;
var ManulifeRoot = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__ManulifeRoot",
  componentId: "sc-1c8dbgg-1"
})(["svg{vertical-align:middle;width:", ";height:", ";path,polygon,rect{stroke:", ";fill:", ";}.manulifeIconSecondary-fill{fill:", ";stroke:none;}.manulifeIconSecondary-stroke{stroke:", ";fill:none;}opacity:", ";}"], function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (_ref5) {
  var height = _ref5.height;
  return height;
}, function (_ref6) {
  var color = _ref6.color;
  return color;
}, function (_ref7) {
  var fill = _ref7.fill;
  return fill;
}, function (_ref8) {
  var secondaryColor = _ref8.secondaryColor;
  return secondaryColor;
}, function (_ref9) {
  var secondaryColor = _ref9.secondaryColor;
  return secondaryColor;
}, function (_ref10) {
  var opacity = _ref10.opacity;
  return opacity;
});
process.env.NODE_ENV !== "production" ? ManulifeRoot.displayName = 'ManulifeRoot' : undefined;

export { ManulifeRoot, SvgRoot };
